export default "__VITE_ASSET__CnNfUmny__"